import Endpoints from "../constants/Endpoints";
import {RestRequestBLOB, RestRequestDELETE, RestRequestGET, RestRequestPOST, RestRequestPUT} from "../libs/RestRequest";
import isResponseValid from "../libs/isResponseValid";
import reduxStore from "../redux/store";
import {clearResource, setResource, setSaveStatusDialog, setSaveStatusError, setSaveStatusLoading, setStepperState} from "../redux/actions";
import Tr from "../translations/Translations";

const BZP_CONTRACT_NOTICE_STATUS = 'bzpContractNoticeStatus';
const BZP_TENDER_RESULT_NOTICE_STATUS = 'bzpTenderResultNoticeStatus';

const showError = (message) => {
	reduxStore.dispatch(setSaveStatusError(message))
}

const getContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getTenderResultNotice = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}
const deleteLastContractNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestDELETE(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId));
		return isResponseValid(resp, showError);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const deleteLastTenderResultNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestDELETE(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE(demandId));
		return isResponseValid(resp, showError);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const createNewContractNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_CREATE_NEW_VERSION(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const createNewTenderResultNoticeVersion = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_CREATE_NEW_VERSION(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeDynamicDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DYNAMIC_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getTenderResultNoticeDynamicDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DYNAMIC_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeTranslations = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_TRANSLATIONS(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getTenderResultNoticeTranslations = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_TRANSLATIONS(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractNoticeDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getTenderResultNoticeDictionaries = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DICTIONARIES(demandId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveContractNoticeDraft = async (demandId, form) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_DRAFT(demandId), form);
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveTenderResultNoticeDraft = async (demandId, form) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_DRAFT(demandId), form);
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveContractNotice = async (demandId, form) => {
	try {
		return await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE(demandId), form);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const saveTenderResultNotice = async (demandId, form) => {
	try {
		return await RestRequestPOST(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE(demandId), form);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishResultNotice = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_PUBLISH(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_TENDER_RESULT_NOTICE_STATUS, resp.result))
			return true;
		}
		return false;
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const rollbackContractNotice = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_ROLLBACK(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishContractNoticeUpdate = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const publishTenderResultNoticeUpdate = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_PUBLISH_UPDATE(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_TENDER_RESULT_NOTICE_STATUS, resp.result))
			return true;
		}
		return false;
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const rollbackContractNoticeUpdate = async (demandId) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_PUBLISH_UPDATE_ROLLBACK(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const saveContractNoticeSection = async (demandId) => {
	reduxStore.dispatch(setSaveStatusLoading());

	try {
		reduxStore.dispatch(setSaveStatusDialog());
		reduxStore.dispatch(setStepperState());
		//await validateSection(DemandValidation.NATIONAL_NOTICE, demandId);
	} catch (error) {
	}
}

const printDemandNoticePreview = async (demandId) => {
	try {
		await RestRequestBLOB(Endpoints.NOTICE_DOWNLOAD_PREVIEW(demandId));
	} catch (e) {
		console.error(e);
	}
}

const getBzpNoticeContent = async (demandId) => {
	try {
		return await RestRequestGET(Endpoints.NATIONAL_NOTICE_BZP_NOTICE_CONTENT(demandId));
	} catch (e) {
		console.error(e);
	}
}

const getTenderResultNoticeContent = async (demandId, resultNoticeId) => {
	try {
		return await RestRequestGET(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_CONTENT(demandId, resultNoticeId));
	} catch (e) {
		console.error(e);
	}
}

const getContractNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractModificationNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_MODIFICATION_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const checkContractNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestPUT(Endpoints.NATIONAL_NOTICE_CONTRACT_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_CONTRACT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const checkTenderResultNoticeStatus = async (demandId) => {
	try {
		const resp = await RestRequestPUT(Endpoints.NATIONAL_NOTICE_TENDER_RESULT_NOTICE_STATUS(demandId));
		if(isResponseValid(resp, showError)) {
			reduxStore.dispatch(setResource(BZP_TENDER_RESULT_NOTICE_STATUS, resp.result))
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const validate = (id) => {
	return RestRequestGET(Endpoints.NATIONAL_NOTICE_VALIDATE(id));
}

const clearResources = (id) => reduxStore.dispatch(clearResource(id));

const getContractPerformingNotice = async (agreementId, positionIds) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE(agreementId, positionIds));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractPerformingNoticeById = async (agreementId, noticeId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_BY_ID(agreementId, noticeId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractPerformingNoticeDictionaries = async (agreementId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_DICTIONARIES(agreementId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const getContractPerformingNoticeTranslations = async (agreementId) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_TRANSLATIONS(agreementId));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const saveContractPerformingNoticeDraft = async (agreementId, form) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_DRAFT(agreementId), form);
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}
const saveContractPerformingNotice = async (agreementId, form) => {
	try {
		const resp = await RestRequestPOST(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE(agreementId), form);
		if(isResponseValid(resp, showError)) {
			return resp;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
		throw e;
	}
}

const deleteLastContractPerformingNoticeVersion = async (agreementId, positionIds) => {
	try {
		const resp = await RestRequestDELETE(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE(agreementId, positionIds));
		return isResponseValid(resp, showError);
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

const createNewContractPerformingNoticeVersion = async (agreementId, positionIds) => {
	try {
		const resp = await RestRequestGET(Endpoints.NATIONAL_NOTICE_CONTRACT_PERFORMING_NOTICE_CREATE_NEW_VERSION(agreementId, positionIds));
		if(isResponseValid(resp, showError)) {
			return resp.result;
		}
	} catch (e) {
		console.error(e);
		showError(Tr('internal_server_error'));
	}
}

export default {
	getContractNotice,
	getContractNoticeTranslations,
	getContractNoticeDictionaries,
	getContractNoticeDynamicDictionaries,
	getContractPerformingNotice,
	getContractPerformingNoticeById,
	getContractPerformingNoticeDictionaries,
	getContractPerformingNoticeTranslations,
	deleteLastContractPerformingNoticeVersion,
	createNewContractPerformingNoticeVersion,
	saveContractPerformingNoticeDraft,
	saveContractPerformingNotice,
	saveContractNoticeSection,
	saveContractNotice,
	saveContractNoticeDraft,
	printDemandNoticePreview,
	publishContractNotice,
	publishResultNotice,
	getContractNoticeStatus,
	getContractModificationNoticeStatus,
	checkContractNoticeStatus,
	checkTenderResultNoticeStatus,
	getTenderResultNoticeContent,
	getTenderResultNotice,
	getTenderResultNoticeDictionaries,
	getTenderResultNoticeTranslations,
	getTenderResultNoticeDynamicDictionaries,
	saveTenderResultNotice,
	saveTenderResultNoticeDraft,
	clearResources,
	validate,
	createNewContractNoticeVersion,
	createNewTenderResultNoticeVersion,
	publishContractNoticeUpdate,
	publishTenderResultNoticeUpdate,
	deleteLastContractNoticeVersion,
	deleteLastTenderResultNoticeVersion,
	rollbackContractNotice,
	rollbackContractNoticeUpdate,
	getBzpNoticeContent,
	BZP_CONTRACT_NOTICE_STATUS,
	BZP_TENDER_RESULT_NOTICE_STATUS
};
